import React, { useEffect, useState } from 'react';
import { Button, Dropdown, message } from 'antd';
import { MessageOutlined, MailOutlined, WhatsAppOutlined, QuestionCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import API from '../api';
import { useAuth } from '../AuthContext';

const tx = {
  ar: {
    title: 'كيف نساعدك؟',
    help: 'مركز المساعدة',
    email: 'راسلنا',
    whatsapp: 'تواصل عبر واتساب',
    chat: 'الدردشة المباشرة',
    needLogin: 'سجّل دخولك للمحادثة',
  },
  en: {
    title: 'How can we help?',
    help: 'Help center',
    email: 'Email us',
    whatsapp: 'WhatsApp',
    chat: 'Live chat',
    needLogin: 'Sign in to chat',
  },
};

export default function SupportFab() {
  const auth = useAuth() || {};
  const lang = auth.lang || 'ar';
  const t = tx[lang] || tx.ar;
  const [open, setOpen] = useState(false);
  const [contact, setContact] = useState({ email: 'support@lancercity.com', whatsapp: '+966500000000' });
  useEffect(() => {
    API.get('/settings/platform/')
      .then((r) => setContact({
        email: r.data.support_email || 'support@lancercity.com',
        whatsapp: (r.data.support_whatsapp_number || '+966500000000').replace(/[^\d+]/g, ''),
      }))
      .catch(() => {});
  }, []);

  const wa = `https://wa.me/${contact.whatsapp.replace(/^\+/, '')}?text=` + encodeURIComponent(lang === 'ar' ? 'مرحبا، أحتاج مساعدة في لانسر سيتي' : 'Hi, I need help on LancerCity');

  return (
    <>
      {open && (
        <div className="support-panel glass-strong animate-pop" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
          <div className="support-head">
            <span style={{ fontWeight: 700, color: 'var(--primary)' }}>{t.title}</span>
            <Button type="text" icon={<CloseOutlined />} onClick={() => setOpen(false)} />
          </div>
          <div className="support-options">
            <Link to="/help" onClick={() => setOpen(false)} className="support-opt">
              <QuestionCircleOutlined /> {t.help}
            </Link>
            <a href={`mailto:${contact.email}`} className="support-opt">
              <MailOutlined /> {t.email}
            </a>
            <a href={wa} target="_blank" rel="noopener noreferrer" className="support-opt support-opt--wa">
              <WhatsAppOutlined /> {t.whatsapp}
            </a>
            <Link to={auth.user ? '/chat' : '/login?next=/chat'}
                  onClick={() => { if (!auth.user) message.info(t.needLogin); setOpen(false); }}
                  className="support-opt">
              <MessageOutlined /> {t.chat}
            </Link>
          </div>
        </div>
      )}
      <button className="support-fab" onClick={() => setOpen((v) => !v)} aria-label="Support">
        {open ? <CloseOutlined /> : <MessageOutlined />}
      </button>
    </>
  );
}
